
import React from 'react';
import Form, { IOwnProps as FormProps } from '../Form';

export interface IOwnProps {
  form?: FormProps;
  children?: React.ReactNode;
  successFullSubmitMessage?: React.ReactNode;
}

export default function LandingTemplate({ form, successFullSubmitMessage, children }: IOwnProps) {
  return <div className="sing-up">
    <section className="bg-home d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center">

          <div className="col-lg-7 col-md-6">
            <div className="mr-lg-5">
              <img src="/images/user/login.svg" className="img-fluid d-block mx-auto" alt="sing up" />
            </div>
          </div>

          {
            form && <div className="col-lg-5 col-md-6">
              <div className="card login-page bg-white shadow rounded border-0">
                <div className="card-body">
                  {
                    successFullSubmitMessage
                      ? successFullSubmitMessage
                      : <Form {...form} />
                  }
                </div>
              </div>
            </div>
          }

          {
            children && <div className="col-lg-5 col-md-6">
              <div className="card login-page bg-white shadow rounded border-0">
                <div className="card-body">
                  {
                    children
                  }
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    </section>
  </div>;
}